import React from 'react';
import * as PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required } from '../../../helper/validation';

import { Container, Group } from './style';
import { RadioForm } from './../';

const GroupRadioForm = ({ name, label, options }) => {
  return (
    <Container>
      <label>{label} <span style={{ color: 'red', fontWeight: '700' }}>*</span></label>

      <Group>
        {
          options.map((option, index) => (
            <Field
              key={index}
              name={name}
              component={RadioForm}
              type={'radio'}
              data={option}
              value={option.value}
              validate={[required]}
            />
          ))
        }
      </Group>
    </Container>
  );
};

GroupRadioForm.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

export default GroupRadioForm;